// extracted by mini-css-extract-plugin
export var container = "BreadCrumbs-module--container--8b470";
export var delim = "BreadCrumbs-module--delim--b0e33";